import { z } from 'zod';

import { LicenseMode } from '@/domain/auth/entities/user.entity.ts';

export const loginDtoSchema = z.object({
  access_token: z.string(),
  refresh_token: z.string(),
});

export const getUserInfosDtoSchema = z.object({
  id: z.string(),
  email: z.string().optional(),
  emailVerified: z.boolean(),
  userName: z.string().optional(),
  name: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  trial: z
    .object({
      isOnTrial: z.boolean().optional(),
      endTimestamp: z.number().optional(),
    })
    .optional(),
  licenses: z
    .array(
      z.object({
        mode: z.nativeEnum(LicenseMode),
        nbProjects: z.number().or(z.string()),
      }),
    )
    .optional(),
});
